import React from 'react';
import { Grid, InputAdornment, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import useForm from 'react-hook-form';
import PropTypes from 'prop-types';
import TextInputFieldWithValidation from '../../ValidationFormElements/TextInputFieldWithValidation';
import PasswordLockIcon from '../../../icons/PassWordLock';
import MainButton from '../../MUI/MainButton';
import recoverPasswordSchema from '../../../validations/auth/recoverPasswordSchema';

import useStyles from './makeStyles';

const RecoverPasswordForm = ({ onSubmit }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const { register, handleSubmit, errors, clearError } = useForm({
    validationSchema: recoverPasswordSchema,
    mode: 'onSubmit',
  });

  return (
    <Grid container spacing={4} justifyContent="center">
      <Grid item xs={11}>
        <Typography className={classes.headerText} align="center">
          {t('changePassword.header')}
        </Typography>
      </Grid>
      <Grid item xs={11}>
        <TextInputFieldWithValidation
          required
          formProps={{ errors, clearError }}
          placeholder={t('changePassword.newPassword')}
          name="newPassword"
          type="password"
          register={register}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <PasswordLockIcon />
              </InputAdornment>
            ),
          }}
        />
      </Grid>
      <Grid item xs={11}>
        <TextInputFieldWithValidation
          required
          type="password"
          formProps={{ errors, clearError }}
          placeholder={t('changePassword.repeatPassword')}
          name="repeatPassword"
          register={register}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <PasswordLockIcon />
              </InputAdornment>
            ),
          }}
        />
      </Grid>
      <Grid item xs={11}>
        <MainButton
          variant="contained"
          onClick={() => handleSubmit(onSubmit)()}
          className={classes.button}
          color="primary"
          width="fullWidth"
        >
          {t('login.login')}
        </MainButton>
      </Grid>
    </Grid>
  );
};

RecoverPasswordForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
};

export default RecoverPasswordForm;
